import Vue from 'vue';
import VueRouter from 'vue-router';
import CampSearch from '../views/CampSearch.vue';
import CampIntro from '../views/CampIntro.vue';
import CampDetail from '../views/CampDetail.vue';
import CampList from '../views/CampList.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'CampSearch',
    component: CampSearch,
  },
  {
    path: '/intro',
    name: 'CampIntro',
    component: CampIntro,
  },
  {
    path: '/camp/:site/:id',
    name: 'CampDetail',
    component: CampDetail,
  },
  {
    path: '/camp/list',
    name: 'CampList',
    component: CampList,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
